import React, { useEffect, useState } from 'react'
import {
  isDescriptionHtmlSource,
  prepareDescriptionValueForSave,
} from 'src/utils/descriptionHtmlSource'
import DescriptionHtmlEditor from './DescriptionHtmlEditor'

type MappingMultilineHtmlEditorProps = {
  value: string
  onChangeData: (value: string) => void
  placeholder?: string
}

const MappingMultilineHtmlEditor: React.FC<MappingMultilineHtmlEditorProps> = ({
  value,
  onChangeData,
  placeholder,
}) => {
  const [htmlSource, setHtmlSource] = useState(() => isDescriptionHtmlSource(value ?? ''))

  useEffect(() => {
    if (isDescriptionHtmlSource(value ?? '')) {
      setHtmlSource(true)
    }
  }, [value])

  return (
    <DescriptionHtmlEditor
      value={value ?? ''}
      htmlSource={htmlSource}
      onHtmlSourceChange={setHtmlSource}
      placeholder={placeholder}
      onChange={(nextValue, options) => {
        const useHtmlSource = htmlSource || options?.htmlSource === true
        if (options?.htmlSource) {
          setHtmlSource(true)
        }
        onChangeData(
          prepareDescriptionValueForSave(nextValue, { htmlSource: useHtmlSource })
        )
      }}
    />
  )
}

export default MappingMultilineHtmlEditor
